import React, {useState, useEffect } from "react";
import { Table, Avatar, Tooltip } from 'antd';
import live from "../services/live.service";
import _ from "lodash";
import Loader from "../components/loader"
import Countdown, { zeroPad } from 'react-countdown';
import { w3cwebsocket as W3CWebSocket } from "websocket";

const moment = require('moment-timezone');
const debug_data = {
  race_day: '20210424',
  race_r: '2',
  race_c: '1',
  time: [10, 30],
}
const debug_mode = (process.env.REACT_APP_DEBUG_MODE === 'true');
const {RaceHandler} = require("../classes/race_handler");
const raceHandler = new RaceHandler(debug_mode, debug_data);

let ws = null;

export default function PrivateRaceSectionalLive() {

  // ----------------------------------------------------------------
  // vars & state
  // ----------------------------------------------------------------

  const [loading, set_loading] = useState(true);
  // UI blocks
  const [current_block, set_current_block] = useState([]);
  const [current_door, set_current_door] = useState('waiting sectional data ...');
  const [sectional_block, set_sectional_block] = useState([]);
  const [finish_block, set_finish_block] = useState([]);
  const [top5_block, set_top5_block] = useState();
  // race status
  const [race_started, set_race_started] = useState(false);
  const [race_end, set_race_end] = useState(false);
  // system
  const [latency, set_latency] = useState(0);
  const [latency_mode, set_latency_mode] = useState(0);
  // UI infos
  const [race_day, set_race_day] = useState();
  const [heurec, set_heurec] = useState();
  const [hippodrome, set_hippodrome] = useState();
  const [numc, set_numc] = useState();
  const [numr, set_numr] = useState();
  const [libc, set_libc] = useState();
  const [prefix, set_prefix] = useState();
  const [race_dist, set_race_dist] = useState();
  const [racetrack_percent, set_racetrack_percent] = useState(0);
  const [race_type, set_race_type] = useState();
  const [next_race, set_next_race] = useState();
  const CET_SUFFIX = ' CET';
  const CET_TZ = 'Europe/Paris';

  function get_moment_in_cet_tz() {
    return moment().tz(CET_TZ);
  }

  // columns sectional
  const columns_sectional = [
    {
      title: 'Rank',
      dataIndex: 'PosC',
      key: 'rank',
      ellipsis: true,
      className: 'sec-col-rank',
    },
    {
      title: '#',
      dataIndex: 'NumP',
      key: 'num',
      ellipsis: true,
      className: 'sec-col-num',
      render: (value, record) => {
        return <Avatar style={{ backgroundColor: `#${record.color}`, color: `#${record.font}`, border: `1px solid #${record.border}`, verticalAlign: 'middle' }} size={25}>
        {value}
        </Avatar>
      },
    },
    {
      title: 'Dist/1st',
      dataIndex: 'Eprm',
      key: 'timefirst',
      ellipsis: true,
      className: 'sec-col-timefirst',
      render: text => text !== 'leader' ? <span>+{text}</span> : <span>{text}</span>,
    },
    {
      title: 'Time',
      dataIndex: 'Tcle',
      key: 'time',
      ellipsis: true,
      className: 'sec-col-time',
    },
    {
      title: 'Max Speed',
      dataIndex: 'Vmax',
      key: 'maxspeed',
      ellipsis: true,
      className: 'sec-col-maxspeed',
    },
  ];

  // columns_current
  const columns_current = [
    {
      title: 'Rank',
      dataIndex: 'PosC',
      key: 'rank',
      ellipsis: true,
      className: 'sec-col-rank',
    },
    {
      title: '#',
      dataIndex: 'NumP',
      key: 'num',
      ellipsis: true,
      className: 'sec-col-num',
      render: (value, record) => {
        return <Avatar style={{ backgroundColor: `#${record.color}`, color: `#${record.font}`, border: `1px solid #${record.border}`, verticalAlign: 'middle' }} size={25}>
        {value}
        </Avatar>
      },
    },
    {
      title: 'Inst. Speed',
      dataIndex: 'Vit',
      key: 'instspeed',
      ellipsis: true,
      className: 'sec-col-time',
    },
    {
      title: 'Dist/1st',
      dataIndex: 'Eprm',
      key: 'distfirst',
      ellipsis: true,
      className: 'sec-col-timefirst',
    },
    {
      title: 'Actual dist',
      dataIndex: 'DrDp',
      key: 'actdist',
      ellipsis: true,
      className: 'sec-col-maxspeed',
    },
  ];

  // columns_top5
  const columns_top5 = [
    {
      title: 'Rank',
      dataIndex: 'PosC',
      key: 'rank',
      ellipsis: true,
      className: 'sec-col-rank',
    },
    {
      title: '#',
      dataIndex: 'NumP',
      key: 'num',
      ellipsis: true,
      className: 'sec-col-num',
      render: (value, record) => {
        return <Avatar style={{ backgroundColor: `#${record.color}`, color: `#${record.font}`, border: `1px solid #${record.border}`, verticalAlign: 'middle' }} size={25}>
        {value || ''}
        </Avatar>
      },
    },
    {
      title: 'Runner',
      dataIndex: 'nomc',
      key: 'nomc',
      ellipsis: true,
      className: 'sec-col-runner',
      render: (text, record) => <Tooltip title={`${text} (${record.jock})`} placement="bottom" overlayClassName="top5_tooltip">
        <span>{`${text || ''} (${record.jock || ''})`}</span>
      </Tooltip>,
    },
    {
      title: 'Dist/1st',
      dataIndex: 'Eprm',
      key: 'distfirst',
      ellipsis: true,
      className: 'sec-col-timefirst',
    },
    {
      title: 'Inst. Speed',
      dataIndex: 'Vit',
      key: 'instspeed',
      ellipsis: true,
      className: 'sec-col-time',
    },
  ];

  // columns_top5_finish
  const columns_top5_finish = [
    {
      title: 'Rank',
      dataIndex: 'PosC',
      key: 'rank',
      ellipsis: true,
      className: 'sec-col-rank',
    },
    {
      title: '#',
      dataIndex: 'NumP',
      key: 'num',
      ellipsis: true,
      className: 'sec-col-num',
      render: (value, record) => {
        return <Avatar style={{ backgroundColor: `#${record.color}`, color: `#${record.font}`, border: `1px solid #${record.border}`, verticalAlign: 'middle' }} size={25}>
        {value || ''}
        </Avatar>
      },
    },
    {
      title: 'Runner',
      dataIndex: 'nomc',
      key: 'nomc',
      ellipsis: true,
      className: 'sec-col-runner',
      render: (text, record) => <Tooltip title={`${text} (${record.jock})`} placement="bottom" overlayClassName="top5_tooltip">
        <span>{`${text || ''} (${record.jock || ''})`}</span>
      </Tooltip>,
    },
    {
      title: 'Time',
      dataIndex: 'Tcle',
      key: 'time',
      ellipsis: true,
      className: 'sec-col-time',
    },
    {
      title: 'Max Speed',
      dataIndex: 'Vmax',
      key: 'maxspeed',
      ellipsis: true,
      className: 'sec-col-maxspeed',
    },
  ];

  // columns_finish
  const columns_finish = [
    {
      title: 'Rank',
      dataIndex: 'PosC',
      key: 'rank',
      ellipsis: true,
      className: 'sec-col-rank',
    },
    {
      title: '#',
      dataIndex: 'NumP',
      key: 'num',
      ellipsis: true,
      className: 'sec-col-num',
      render: (value, record) => {
        return <Avatar style={{ backgroundColor: `#${record.color}`, color: `#${record.font}`, border: `1px solid #${record.border}`, verticalAlign: 'middle' }} size={25}>
        {value || ''}
        </Avatar>
      },
    },
    {
      title: 'Time',
      dataIndex: 'Tcle',
      key: 'time',
      ellipsis: true,
      className: 'sec-col-time',
    },
    {
      title: 'Max Speed',
      dataIndex: 'Vmax',
      key: 'maxspeed',
      ellipsis: true,
      className: 'sec-col-maxspeed',
    },
  ];

  // ----------------------------------------------------------------
  // methods
  // ----------------------------------------------------------------

  // get_meeting_data -----------------------------------------------
  const get_meeting_data = async (race_day) => {
    live
      .meeting_list({
        date: (debug_mode) ? debug_data.race_day : race_day
      })
      .then(r => {
        if (r && r.data) {
          raceHandler.set_meeting_list(r.data);
          race_watcher();
          init_websocket();
          set_loading(false);
        }
      })
  }

  // get_runners_details --------------------------------------------
  const get_runners_details = async (d, r, c) => {
    console.log('get_runners_details', d, r, c);
    live
      .runners_details({
        date: d,
        numr: r,
        numc: c,
      })
      .then(r => {
        if (r && r.data) {
          raceHandler.set_race_info(r.data);
          set_race_type(r.data[0].disc);
        }
      })
  }

  // get_top5_block -----------------------------------------------
  const get_top5_block = async (data) => {
    let tmp = data.slice(0,5);
    let merged = raceHandler.merge_race_info(tmp);
    set_top5_block(merged);
  }

  // init_websocket -------------------------------------------------
  const init_websocket = () => {
    let ws_mode = (process.env.REACT_APP_WSS_MODE === 'true') ? 'wss' : 'ws';
    let ws_port = process.env.REACT_APP_WS_CLIENT_PORT;
    let ws_addr = `${ws_mode}://${process.env.REACT_APP_WS_SRV}${(ws_port) && `:${ws_port}`}`;
    console.log('ws_addr', ws_addr);
    ws = new W3CWebSocket(ws_addr);
    let lat_cpt = 0;
    let uuid = null;
    console.log('WS init', ws_addr);

    ws.onopen = () => {
      console.log('WS connected');
    }

    ws.onmessage = async (packet) => {
      let a = JSON.parse(packet.data);

      // connection uuid
      if (a.uuid) {
        uuid = a.uuid;
        return;
      } else {
        set_race_started(true);
      }

      // set_latency
      let lat = Date.now() - a.WS_TS;
      let l_mode = 0;
      if (lat_cpt > 10 && uuid) {
        lat_cpt = 0;
        set_latency(lat);
        if (lat < 100) {
          l_mode = 0;
        } else if (lat < 200) {
          l_mode = 1;
        } else if (lat < 500) {
          l_mode = 2;
        } else if (lat < 1000){
          l_mode = 3;
        } else {
          l_mode = 4;
        }

        // @koj force latency to 2Hz, nothing sent to server by client
        l_mode = 2
        set_latency_mode(l_mode);
        ws.send(`{"uuid": "${uuid}", "cmd":"latency","mode":${l_mode}}`);
      } else {
        lat_cpt++;
      }

      if (a.sectional) {
        set_sectional_block(a.sectional);
        gen_current_door(a.sectional);
        if (a.sectional[a.sectional.length-1][0] === 'PCARR') {
          set_race_end(true);
          add_finish(a.sectional[a.sectional.length-1][1].slice());
        }
      } else {
        race_watcher(a['Ctxt']['reu'], a['Ctxt']['cou']).then();
        if (raceHandler.race_end === false) {
          set_race_end(false);
          let data = _.orderBy(a.captures, [function(record) {return record.PosC}], ['asc']);
          progression_watcher(data).then();
          set_current_block(data);
          get_top5_block(data.slice()).then();
        }
      }

    }

    ws.onclose = () => {
      console.log("WS CLOSED");
      init_websocket();
    }

    ws.onerror = (e) => {
      console.log("WS ERROR", e);
      ws.close();
    }
  }

  const GetLatencyBloc = () => {
    switch (latency_mode) {
      case 0:
        return <div className="system_block latency0">
          Low latency (refesh 100ms, latency: {latency}) 
        </div>
      case 1:
        return <div className="system_block latency1">
          medium latency (refesh 300ms, latency: {latency})
        </div>
      case 2:
        return <div className="system_block latency2">
          medium latency (refesh 500ms, latency: {latency})
        </div>
      case 3:
        return <div className="system_block latency3">
          slow network (refesh 1s, latency: {latency})
        </div>
      case 4:
        return <div className="system_block latency4">
          network issue (live impossible, only sectional, latency: {latency})
        </div>
      default:
        return <></>
    }
  }

  // add_finish -----------------------------------------------------
  const add_finish = (last_sectional) => {
    let finish = raceHandler.add_finish(last_sectional);
    set_finish_block(finish.slice());
    get_top5_block(finish).then();
  }

  // gen_current_door -----------------------------------------------
  const gen_current_door = (sec) => {
    if (race_end) {
      set_current_door('FINISH');
      return;
    }
    if (sec[sec.length-1][0] === 'PCDEP') {
      set_racetrack_percent(0);
      let d = (raceHandler.get_current_race()) ? raceHandler.get_current_race().dist : 0;
      let next = Number(d) - 200;
      if (d % 200 !== 0) {
        next = Number(d) - (d % 200);
      }
      set_current_door(`DEP - ${next}m`);  
    } else {
      let cur = sec[sec.length-1][0].replace('PC', '');
      if (cur === 'ARR') {
        set_current_door('FINISH');
        return;
      }
      let next = Number(cur) - 200;
      if (next > 0) {
        set_current_door(`${cur}m - ${next}m`);  
      } else {
        set_current_door(`${cur}m - ARR`);  
      }
    }

  }

  // progression_watcher --------------------------------------------
  const progression_watcher = async (data) => {
    if (race_end) {
      set_racetrack_percent(100);
    }
    for (let i=0; i < data.length; i++) {
      if (data[i].PosC === 1 && raceHandler.current_race) {
        let DrDp = Math.floor(Number(data[i].DrDp));
        let p = Math.floor( DrDp / Number(raceHandler.current_race?.dist) * 100);
        if (!isNaN(p)) {
          set_racetrack_percent(prev => {
            if (p <= prev) {
              return prev;
            }
            if (p >= 100) {
              return 100;
            }
            return p;
          })
        }
        break;
      }
    }
  }

  // race_watcher ---------------------------------------------------
  const race_watcher = async (r, c) => {
    let race = null;
    let next_race = null;
    if (r && c) {
      if (raceHandler.is_new_race(r,c)) {
        console.log('NEW RACE FOUND', r, c)
        race = raceHandler.get_current_race();
        next_race = raceHandler.get_next_race();
        set_race_end(false);
      }
    } else {
      race = raceHandler.search_race();
      next_race = raceHandler.get_next_race();
    }

    if (race) {
      set_race_dist(race.dist);
      set_hippodrome(race.hippodrome);
      set_heurec(race.heurec);
      set_numc(race.numc);
      set_numr(race.numr);
      set_libc(race.libc);
      set_prefix(race.prefix);
      get_runners_details(race.date, race.numr, race.numc).then();
    }
    if (next_race) {
      set_next_race(
        <div className="next_race">
          <h2>
            <span className="title_prefix">{`>> NEXT RACE`}</span> 
            {next_race.heurec} {CET_SUFFIX}
            <span className="rc_block">{`R${next_race.numr}C${next_race.numc}`}</span> 
            MEETING {next_race.numr} {next_race.hippodrome} / RACE {next_race.numc} - {next_race.libc}
          </h2>
        </div>
      );  
    }
  }

  // ----------------------------------------------------------------
  // components
  // ----------------------------------------------------------------

  // CountDownToRace ----------------------------------------------
  const CountDownToRace = () => {
    return (
      <Countdown
        date={moment.tz(heurec, "HH:mm", 'Europe/Paris').unix() * 1000}
        renderer={({ hours, minutes, seconds, completed }) => {
          if (completed) {
            return <span className="countdownComplete">Race should start shortly ...</span>;
          } 
          else {
            return <><span className="label">Planned to start in</span><span>{zeroPad(hours)}:{zeroPad(minutes)}:{zeroPad(seconds)}</span></>
          }  
        }}
      />
    )
  }

  
  // ----------------------------------------------------------------
  // useEffect 
  // ----------------------------------------------------------------

  // first load
  useEffect(() => {
    if (debug_mode) {
      set_race_day(debug_data.race_day);
    } else {
      set_race_day(get_moment_in_cet_tz().format('YMMDD'));
    }
    set_next_race(
      <div className="next_race">
        <h1><span className="title_prefix">NO NEXT RACE</span></h1>
      </div>
    )
    return () => {
      set_loading(false);
      if (ws) {
        console.log('CLOSE WS USEEFFECT');
        ws.close();
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  // race_day change
  useEffect(() => {
    if (race_day) {
      console.log('race_day', race_day);
      get_meeting_data(race_day).then();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [race_day])

  // race end
  useEffect(() => {
    if (race_end) {
      progression_watcher([]).then();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [race_end])


  // ----------------------------------------------------------------
  // render
  // ----------------------------------------------------------------

  return (
    <div id="race_live_wrapper" key="race_live_wrapper" className="race_live_wrapper">
      {loading ? <Loader /> :
        <>
        <div key="race_live_header" className="race_live_header">
          {heurec ? 
            <h1><span className="title_prefix">{prefix}</span>
              {heurec}{CET_SUFFIX}
              <span className="rc_block">{`R${numr}C${numc}`}</span>
              MEETING {numr} {hippodrome} / RACE {numc} - {libc}
            </h1>
            :
            <h1>No more race today</h1>
          }
        </div>

        <div key="race_live_panel_info" className="race_live_panel_info">
          <div key="race_info_wrapper" className="race_info_wrapper">
            {race_dist && <div key="race_info_panel" className="race_info_panel">
              <span className="race_info_title">
                {race_dist}m {race_type}
              </span>
            </div>}
          </div>
          <div key="race_ranking_panel" className="race_ranking_panel">
            <span className="title">TOP 5</span>
            <Table 
              columns={(race_end) ? columns_top5_finish : columns_top5}
              dataSource={top5_block} 
              className="block_top_5" 
              pagination={false}
              tableLayout="fixed" 
            />
          </div>
          <div key="race_progression_wrapper" className="race_progression_wrapper">
            <div key="race_progression_panel" className="race_progression_panel">
              <span className="racetrack_title">RACETRACK</span>
              <span className="racetrack_value">{`${racetrack_percent} %`}</span>
            </div>
          </div>
        </div>
        
        <h1 className="sec_block_title">LIVE SECTIONS</h1>
        <div key="sec_block_wrapper" className="sec_block_wrapper">
          {!race_started && <div key="countdown_block" className="countdown_block">
            {heurec && <CountDownToRace />}
          </div>}
          {race_started && <div key="sec_block_past" className="sec_block_past">
            {sectional_block.map(a => {
              if ((a[0] !== 'PCDEP')&&(a[0] !== 'PCARR')) {
                return <div key={`sec_block_col${a[0]}`} className="sec_block_col">
                  <span className="sec_block_pc">{a[0]}</span>
                  <Table 
                    key={a[0]}
                    columns={columns_sectional}
                    dataSource={a[1]} 
                    className="sec_block" 
                    pagination={false} 
                  />  
                </div>
              }
              return null;
            })}
          </div>}
          {race_started && <>
            <div key="sec_block_current" className="sec_block_current">
              <div key={`sec_block_col${current_door}`} className={race_started ? "sec_block_col live" : "sec_block_col"}  >
              <span className={race_end ? "sec_block_pc_finish" : "sec_block_pc_live"}>
                {current_door}
              </span>
              <Table 
                columns={race_end ? columns_finish : columns_current} 
                dataSource={race_end ? finish_block : current_block} 
                className={race_end ? "sec_block finish" : "sec_block live"}
                pagination={false}
                tableLayout="fixed" 
              />
            </div>
          </div></>}
        </div>
        <div className="race_live_footer">
          <GetLatencyBloc />
          <div className="next_race_wrapper">
            {next_race}
          </div>
        </div>
        </>
      }
    </div>
  );
}